import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import { useNavContext } from "../context/nav_context";
import {
  MATCH_PHASE_TYPE_REGULAR_LEAGUE,
  MATCH_PHASE_TYPE_PLAYOFF,
  MATCH_PHASE_TYPE_PLAYIN,
  MATCH_FORMAT_PA3,
  MATCH_FORMAT_BO5,
  MATCH_FORMAT_BO1,
  api_v3_get_tournament_by_id,
  api_v3_list_of_players,
  api_v3_create_match,
} from "../utils/constants";
import { TfiAngleLeft, TfiClose } from "react-icons/tfi";
import { ButtonModern } from "../components";

const AdminMatches = () => {
  const { tournamentId } = useParams();
  const { user, accessToken } = useNavContext();

  const [divisionsInProgress, setDivisionsInProgress] = useState(true);
  const [divisionsError, setDivisionsError] = useState(false);
  const [, setDivisionsCompleted] = useState(false);

  const [playersInProgress, setPlayersInProgress] = useState(false);
  const [playersError, setPlayersError] = useState(false);

  // Form popups selectors
  const [showDivisionsSelector, setShowDivisionsSelector] = useState(false);
  const [showPhaseSelector, setShowPhaseSelector] = useState(false);
  const [showGroupSelector, setShowGroupSelector] = useState(false);
  const [showLeagueDaySelector, setShowLeagueDaySelector] = useState(false);
  const [showPlayoffPhaseSelector, setShowPlayoffPhaseSelector] =
    useState(false);
  const [showMatchSystemSelector, setShowMatchSystemSelector] = useState(false);
  const [showPlayerASelector, setShowPlayerASelector] = useState(false);
  const [showPlayerBSelector, setShowPlayerBSelector] = useState(false);

  // Form selectors data
  const [divisions, setDivisions] = useState([]);
  const phases = [
    MATCH_PHASE_TYPE_REGULAR_LEAGUE,
    MATCH_PHASE_TYPE_PLAYOFF,
    MATCH_PHASE_TYPE_PLAYIN,
  ];
  const league_days = [1, 2, 3, 4, 5, 6, 7];
  const playoff_type = ["Ascenso", "Descenso", "Campeón división", "Desempate"];
  const match_format = [MATCH_FORMAT_PA3, MATCH_FORMAT_BO5, MATCH_FORMAT_BO1];
  const [players, setPlayers] = useState([]);

  const [selectedDivision, setSelectedDivision] = useState();
  const [selectedPhase, setSelectedPhase] = useState(); // if playoff load all group players
  const [selectedGroup, setSelectedGroup] = useState();
  const [selectedLeagueDay, setSelectedLeagueDay] = useState();
  const [selectedPlayoffPhase, setSelectedPlayoffPhase] = useState();
  const [selectedMatchSystem, setSelectedMatchSystem] = useState();
  const [selectedPlayerA, setSelectedPlayerA] = useState();
  const [selectedPlayerB, setSelectedPlayerB] = useState();

  const [saveBtnInProgress, setSaveBtnInProgress] = useState(false);
  const [saveBtnDone, setSaveBtnDone] = useState(false);
  const [saveBtnError, setSaveBtnError] = useState(false);

  const clearSelections = (options) => {
    setSaveBtnDone(false);
    setSaveBtnError(false);
    if (options.includes("DIVISIONS")) {
      setSelectedDivision();
    }
    if (options.includes("PHASE")) {
      setSelectedPhase();
    }
    if (options.includes("GROUP")) {
      setSelectedGroup();
    }
    if (options.includes("LEAGUE_DAY")) {
      setSelectedLeagueDay();
    }
    if (options.includes("PLAYOFF_PHASE")) {
      setSelectedPlayoffPhase();
    }
    if (options.includes("MATCH_SYSTEM")) {
      setSelectedMatchSystem();
    }
    if (options.includes("PLAYERS")) {
      setSelectedPlayerA();
      setSelectedPlayerB();
    }
  };

  useEffect(() => {
    const loadDivisions = async () => {
      const url = api_v3_get_tournament_by_id(tournamentId);

      try {
        setDivisionsInProgress(true);
        const response = await axios.get(url);
        if (response.status === 200) {
          const divs = response.data.divisions.sort((a, b) =>
            a.sequence > b.sequence ? 1 : -1
          );
          setDivisions(divs);
          setDivisionsInProgress(false);
          setDivisionsError(false);
          setDivisionsCompleted(true);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setDivisionsInProgress(false);
          setDivisionsError(true);
          return false;
        }
      } catch (error) {
        setDivisionsInProgress(false);
        setDivisionsError(true);
        return false;
      }
    };
    if (tournamentId) {
      loadDivisions();
    }
  }, [tournamentId]);

  useEffect(() => {
    if (selectedDivision || selectedGroup) {
      loadPlayers();
    }
  }, [selectedDivision, selectedGroup]);

  const loadPlayers = async () => {
    const url = api_v3_list_of_players();

    try {
      setPlayersInProgress(true);
      setPlayersError(false);
      const response = await axios.get(url);
      if (response.status === 200) {
        console.log(
          `(${response.status}) response: ${JSON.stringify(response.data)}`
        );
        setPlayers(
          response.data.sort((a, b) => a.username.localeCompare(b.username))
        );
      } else {
        console.log(`(${response.status}) response: ${response.data}`);
        setPlayersInProgress(false);
        setPlayersError(true);
        return false;
      }

      setPlayersInProgress(false);
      setPlayersError(false);

      return true;
    } catch (error) {
      setPlayersInProgress(false);
      setPlayersError(false);
      return false;
    }
  };

  const createMatch = async () => {
    console.log("create match"); // DEBUG
    console.log(selectedPlayerA);
    console.log(selectedPlayerB);
    const divName = divisions.filter(
      (div) => div.divisionId === selectedDivision
    )[0].name;
    var matchTemplate = {
      tournamentId: tournamentId,
      divisionId: selectedDivision,
      divisionName: divName,
      leagueDay: selectedLeagueDay ? selectedLeagueDay : 0,
      gamesFormat: selectedMatchSystem,
      phase: selectedPhase,
      playoffType: selectedPlayoffPhase,
      status: "NOT_STARTED",
      playerAid: selectedPlayerA,
      playerBid: selectedPlayerB,
    };

    console.log(JSON.stringify(matchTemplate)); // DEBUG

    setSaveBtnInProgress(true);
    try {
      console.log(`Saving....`);
      var access_token = accessToken || localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `AdminMatches :: createMatch -> it's necessary be logged`
        );
        return false;
      }
      const config = {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      };

      const response = await axios.post(
        api_v3_create_match(),
        matchTemplate,
        config
      );
      if (response.status === 201) {
        setSaveBtnInProgress(false);
        setSaveBtnError(false);
        clearSelections(["PLAYERS"]);
        setSaveBtnDone(true);
        return true;
      } else {
        setSaveBtnInProgress(false);
        setSaveBtnDone(false);
        setSaveBtnError(true);
        console.log(
          `(${response.status}) response: ${JSON.stringify(response.data)}`
        );
        return false;
      }
    } catch (error) {
      setSaveBtnInProgress(false);
      setSaveBtnDone(false);
      setSaveBtnError(true);
      return false;
    }
  };

  if (!user) {
    console.log(user);
    return (
      <Wrapper className="page section section-center">
        Debes iniciar sesión para acceder a esta página.
      </Wrapper>
    );
  }

  if (!user.isAdmin) {
    return (
      <Wrapper className="page section section-center">
        Lo siento majete pero estás intentando acceder a donde no debes.
      </Wrapper>
    );
  }

  if (divisionsInProgress) {
    return (
      <Wrapper>
        <div className="loading">
          <div className="lds-dual-ring"></div>
        </div>
      </Wrapper>
    );
  }

  if (divisionsError) {
    return (
      <Wrapper>
        <div className="error">
          Ha ocurrido un error cargando las divisiones
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Selectors>
        {showDivisionsSelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowDivisionsSelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona la división</h3>
              <div className="list">
                {divisions.map((div) => {
                  return (
                    <div
                      key={`division-selector-${div.divisionId}`}
                      className="item"
                      onClick={() => {
                        clearSelections([
                          "DIVISIONS",
                          "PHASE",
                          "GROUP",
                          "LEAGUE_DAY",
                          "PLAYOFF_PHASE",
                          "PLAYERS",
                        ]);
                        setSelectedDivision(div.divisionId);
                        setShowDivisionsSelector(false);
                      }}
                    >
                      <span>{div.name}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}
        {showPhaseSelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowPhaseSelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona la fase</h3>
              <div className="list">
                {phases.map((phase) => {
                  return (
                    <div
                      key={`phase-selector-${phase}`}
                      className="item"
                      onClick={() => {
                        clearSelections([
                          "PHASE",
                          "GROUP",
                          "LEAGUE_DAY",
                          "PLAYOFF_PHASE",
                          "PLAYERS",
                        ]);
                        setSelectedPhase(phase);
                        setShowPhaseSelector(false);
                      }}
                    >
                      <span>{phase}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}

        {showGroupSelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowGroupSelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona el grupo</h3>
              <div className="list">
                {divisions
                  .filter((div) => div.divisionId === selectedDivision)[0]
                  .groups.map((group) => {
                    return (
                      <div
                        key={`group-selector-${group.groupId}`}
                        className="item"
                        onClick={() => {
                          clearSelections([
                            "GROUP",
                            "PLAYOFF_PHASE",
                            "PLAYERS",
                          ]);
                          setSelectedGroup(group.groupId);
                          setShowGroupSelector(false);
                        }}
                      >
                        <span>{group.name}</span>
                      </div>
                    );
                  })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}

        {showLeagueDaySelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowLeagueDaySelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona la jornada</h3>
              <div className="list">
                {league_days.map((league_day) => {
                  return (
                    <div
                      key={`league_day-selector-${league_day}`}
                      className="item"
                      onClick={() => {
                        clearSelections([
                          "LEAGUE_DAY",
                          "PLAYOFF_PHASE",
                          "PLAYERS",
                        ]);
                        setSelectedLeagueDay(league_day);
                        setShowLeagueDaySelector(false);
                      }}
                    >
                      <span>{league_day}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}

        {showPlayoffPhaseSelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowPlayoffPhaseSelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona la fase de playoff</h3>
              <div className="list">
                {playoff_type.map((phase) => {
                  return (
                    <div
                      key={`playoffphase-selector-${phase}`}
                      className="item"
                      onClick={() => {
                        // clearSelections not necessary
                        setSelectedPlayoffPhase(phase);
                        setShowPlayoffPhaseSelector(false);
                      }}
                    >
                      <span>{phase}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}

        {showMatchSystemSelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowMatchSystemSelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona el formato del partido</h3>
              <div className="list">
                {match_format.map((format) => {
                  return (
                    <div
                      key={`matchformat-selector-${format}`}
                      className="item"
                      onClick={() => {
                        // clearSelections not necessary
                        setSelectedMatchSystem(format);
                        setShowMatchSystemSelector(false);
                      }}
                    >
                      <span>{format}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}

        {showPlayerASelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowPlayerASelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona el jugador A</h3>
              <div className="list">
                {players.map((player) => {
                  return (
                    <div
                      key={`playerA-selector-${player.playerId}`}
                      className="item"
                      onClick={() => {
                        // clearSelections not necessary
                        setSelectedPlayerA(player.playerId);
                        setShowPlayerASelector(false);
                      }}
                    >
                      <span>{player.username}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}

        {showPlayerBSelector ? (
          <Selector>
            <div className="selector-container">
              <div
                className="close-icon"
                onClick={() => setShowPlayerBSelector(false)}
              >
                <TfiClose />
              </div>
              <h3>Selecciona el jugador B</h3>
              <div className="list">
                {players.map((player) => {
                  return (
                    <div
                      key={`playerB-selector-${player.playerId}`}
                      className="item"
                      onClick={() => {
                        // clearSelections not necessary
                        setSelectedPlayerB(player.playerId);
                        setShowPlayerBSelector(false);
                      }}
                    >
                      <span>{player.username}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </Selector>
        ) : (
          ""
        )}
      </Selectors>

      <article>
        <div className="title">
          <h2>Admin Matches</h2>
          <div className="underline"></div>
        </div>
        <div className="other-options">
          <Link to="/admin/" className="btn">
            <TfiAngleLeft />
            Admin Home
          </Link>
        </div>
        <div className="content">
          <p>
            Rellena los datos a continuación para crear un nuevo partido. Esta
            funcionalidad está pensada para poder crear las partidas de
            playoffs:
          </p>
          <div className="new-match-form">
            {/* DIVISION SELECTOR */}
            <div className="new-match-form-selector">
              <p className="explanation">Selecciona la división:</p>
              <div
                className="btn"
                onClick={() => setShowDivisionsSelector(true)}
              >
                {selectedDivision ? (
                  <div>
                    <span role="img" aria-label="check">
                      ✅
                    </span>{" "}
                    {
                      divisions.filter(
                        (d) => d.divisionId === selectedDivision
                      )[0].name
                    }
                  </div>
                ) : (
                  <div>
                    <span role="img" aria-label="pending">
                      ❗
                    </span>{" "}
                    ¿división?{" "}
                  </div>
                )}
              </div>
            </div>

            {/* PHASE SELECTOR */}
            {selectedDivision ? (
              <div className="new-match-form-selector">
                <p className="explanation">Selecciona la fase:</p>
                <div className="btn" onClick={() => setShowPhaseSelector(true)}>
                  {selectedPhase ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {selectedPhase}
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿fase?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* GROUP SELECTOR */}
            {selectedDivision &&
            selectedPhase === MATCH_PHASE_TYPE_REGULAR_LEAGUE ? (
              <div className="new-match-form-selector">
                <p className="explanation">Selecciona el grupo:</p>
                <div className="btn" onClick={() => setShowGroupSelector(true)}>
                  {selectedGroup ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {
                        divisions
                          .filter((d) => d.divisionId === selectedDivision)[0]
                          .groups.filter((g) => g.groupId === selectedGroup)[0]
                          .name
                      }
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿Grupo?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* LEAGUE_DAY SELECTOR */}
            {selectedDivision &&
            selectedPhase === MATCH_PHASE_TYPE_REGULAR_LEAGUE &&
            selectedGroup ? (
              <div className="new-match-form-selector">
                <p className="explanation">Selecciona la jornada:</p>
                <div
                  className="btn"
                  onClick={() => setShowLeagueDaySelector(true)}
                >
                  {selectedLeagueDay ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {selectedLeagueDay}
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿Nº de jornada?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* PLAYOFF_PHASE SELECTOR */}
            {selectedDivision &&
            (selectedPhase === MATCH_PHASE_TYPE_PLAYOFF ||
              selectedPhase === MATCH_PHASE_TYPE_PLAYIN) ? (
              <div className="new-match-form-selector">
                <p className="explanation">Selecciona el tipo de playoff:</p>
                <div
                  className="btn"
                  onClick={() => setShowPlayoffPhaseSelector(true)}
                >
                  {selectedPlayoffPhase ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {selectedPlayoffPhase}
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿tipo playoff?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* MATCH_FORMAT SELECTOR */}
            {selectedDivision &&
            selectedPhase &&
            (selectedPlayoffPhase || selectedLeagueDay) ? (
              <div className="new-match-form-selector">
                <p className="explanation">
                  Selecciona el formato del partido:
                </p>
                <div
                  className="btn"
                  onClick={() => setShowMatchSystemSelector(true)}
                >
                  {selectedMatchSystem ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {selectedMatchSystem}
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿formato de partido?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* PLAYER_A SELECTOR */}
            {!playersInProgress &&
            !playersError &&
            selectedDivision &&
            selectedPhase &&
            selectedMatchSystem ? (
              <div className="new-match-form-selector">
                <p className="explanation">Selecciona al jugador A (host):</p>
                <div
                  className="btn"
                  onClick={() => setShowPlayerASelector(true)}
                >
                  {selectedPlayerA ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {
                        players.filter(
                          (player) => player.playerId === selectedPlayerA
                        )[0].username
                      }
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿player A?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}

            {/* PLAYER_B SELECTOR */}
            {!playersInProgress &&
            !playersError &&
            selectedDivision &&
            selectedPhase &&
            selectedMatchSystem ? (
              <div className="new-match-form-selector">
                <p className="explanation">Selecciona al jugador B (guest):</p>
                <div
                  className="btn"
                  onClick={() => setShowPlayerBSelector(true)}
                >
                  {selectedPlayerB ? (
                    <div>
                      <span role="img" aria-label="check">
                        ✅
                      </span>{" "}
                      {
                        players.filter(
                          (player) => player.playerId === selectedPlayerB
                        )[0].username
                      }
                    </div>
                  ) : (
                    <div>
                      <span role="img" aria-label="pending">
                        ❗
                      </span>{" "}
                      ¿player B?{" "}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {selectedDivision &&
        selectedPhase &&
        selectedPlayerA &&
        selectedPlayerB &&
        !saveBtnInProgress ? (
          <ButtonModern
            text="Crear partido"
            marginLeft="2rem"
            fontSize="0.8em"
            onClick={createMatch}
          />
        ) : (
          ""
        )}
        {saveBtnInProgress ? <div className="lds-dual-ring-small"></div> : ""}
        {!saveBtnInProgress && saveBtnDone && !saveBtnError ? (
          <p>
            <span role="img" aria-label="check">
              ✅
            </span>{" "}
            Se ha creado la partida correctamente
          </p>
        ) : (
          ""
        )}
        {!saveBtnInProgress && !saveBtnDone && saveBtnError ? (
          <p>Se ha producido un error creando la partida, inténtalo de nuevo</p>
        ) : (
          ""
        )}
      </article>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 1rem;
  .title {
    margin-bottom: 4rem;
  }
  .error {
    width: 100%;
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    margin: 1rem;
    margin-top: 2rem;
  }

  .new-match-form {
    display: flex;
    flex-wrap: wrap;
  }

  .new-match-form-selector {
    border: 1px solid var(--clr-grey-1);
    margin: 0.8rem;
    padding: 0.5rem;
  }
`;

const Selectors = styled.div``;

const Selector = styled.div`
  position: fixed; /* Sit on top of the page content */
  /*display: none; /*Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  display: flex;
  justify-content: center;
  align-items: center;

  .close-icon {
    width: 100%;
    z-index: 10;
    color: var(--clr-black);
    display: flex;
    justify-content: flex-end;
    cursor: pointer;

    *:hover {
      animation: pulse 2s infinite;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      }

      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      }
    }
  }

  .selector-container {
    width: 80%;
    height: 80%;
    background-color: var(--clr-grey-1);
    z-index: 5;
    color: var(--clr-black);
    padding: 2rem;
    overflow: auto;

    .list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      height: 80%;
    }

    .item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 2rem;
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);

      img {
        width: 10rem;
      }
      span {
        padding: 0.5rem;
        color: var(--clr-black);
      }
    }
    .item:hover {
      -webkit-filter: grayscale(0);
      filter: grayscale(0);
    }
  }
`;

export default AdminMatches;
